export default {
  locale: "en",
  name: "Configuration manager",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "useCustomEmailTemplate",
        displayName: "Use custom templates",
        description: "Activate this to allow the user to create their own templates",
        helpText: "If no template is created and active the default template will be used",
      },
      {
        fieldName: "pedircodigoseguridad",
        displayName: "Activar campo CCV para PCIProxy",
        description: "Activa el campo CCV en el formulario de pago para el método PCI Proxy",
        helpText:
          "Actualmente sólo funciona para PCI Proxy pero podría expandirse para otros métodos de pago en el futuro",
      },
    ],
  },
};
